import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles((theme) => ({
    bold: {
        fontWeight: 600,
    },
    listSubheader: {
        paddingBottom: '8px',
        paddingTop: '8px',
        background: theme.palette.grey[theme.palette.type === 'dark' ? 900 : 300],
        fontWeight: 'bold',
        fontSize: '18px',
        lineHeight: '18px',
    },
}));
